import axios from 'axios'
import store from '../../store/index'

const state = {
  spots: [],
}

const mutations = {
  spots_data (state, spots) {
    state.spots = spots
  },
}

const actions = {
  createBulkSpots ({ commit }, spots) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/locationSpots/bulk',
        data: spots,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getLocationSpots ({ commit }, locationId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/locationSpots/location?locationId=' + locationId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getClassifications ({ commit }, locationId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/locationSpots/location/classifications/?locationId=' + locationId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getSpots ({ commit }, spotClassificationId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/locationSpots/location/spots/?spotClassificationId=' + spotClassificationId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getSpotsByClassification ({ commit }, spotClassificationId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/locationSpots/classification/spots/?spotClassificationId=' + spotClassificationId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  getClassificationByClassificationId ({ commit }, spotClassificationId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/locationSpots/classification/?spotClassificationId=' + spotClassificationId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  updateClassification ({ commit }, classification) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/locationSpots',
        data: classification,
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  createSpot ({ commit }, spots) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/locationSpots',
        data: spots,
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteSpot ({ commit }, eventSpotId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/locationSpots?eventSpotId=' + eventSpotId,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  refreshSpotCode ({ commit }, eventSpotId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/locationSpots/code/refresh?eventSpotId=' + eventSpotId,
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
  deleteSpotClassification ({ commit }, spotClassificationId) {
    return new Promise((resolve, reject) => {
      axios({
        url: '/locationSpots/remove/classification?spotClassificationId=' + spotClassificationId,
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.getters.token,
        },
      })
        .then(resp => {
          resolve(resp)
        })
        .catch(err => {
          reject(err)
        })
    })
  },
}

export default {
  state,
  mutations,
  actions,
}
